// @ts-expect-error virtual import
import type { RouteLocationNormalized } from '#app'
// @ts-expect-error virtual file
import { useRoute } from '#imports'
import { computed } from 'vue'

export function useReturnUrl(route?: RouteLocationNormalized) {
  return computed(() => {
    if (route) {
      return String(route.query.returnUrl || '')
    }
    return String(useRoute().query.returnUrl || '')
  })
}
